import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TeamInjuriesRoutingModule } from "./team-injuries-routing.module";
import { TeamInjuriesComponent } from "./team-injuries.component";
import { SharedModule } from "../../shared/shared.module";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { WorkoutsReducer } from "./store/workouts.reducer";
import { WorkoutsEffects } from "./store/workouts.effects";
import { Fields } from "./store";
import { TeamAllInjuriesComponent } from "./team-injuries-list/team-all-injuries.component";
import { TeamPlayerInjuriesComponent } from "./team-player-injuries/team-player-injuries.component";
import { TeamInjuryDetailsComponent } from "./team-injury-details/team-injury-details.component";

@NgModule({
  imports: [
    CommonModule,
    TeamInjuriesRoutingModule,

    SharedModule,

    StoreModule.forFeature(Fields.Module, WorkoutsReducer),
    EffectsModule.forFeature([WorkoutsEffects]),
  ],
  declarations: [
    TeamInjuriesComponent,
    TeamAllInjuriesComponent,
    TeamPlayerInjuriesComponent,
    TeamInjuryDetailsComponent,
  ],
})
export class TeamInjuriesModule {}



// WEBPACK FOOTER //
// ./src/app/pages/team-injuries/team-injuries.module.ts